<template lang="pug">
.gzzoc-pdf-wrapper
    .gzzoc-pdf
        img.logo(src="~public/images/gzzoc/logo-pdf.png", width="267")
        .title
            | {{$t('gzzoc.reportTitle')}}
        .person
            .item
                |{{$t('gzzoc.name')}}：{{result.name}}
            .item
                |{{$t('gzzoc.gender')}}: {{result.gender}}
            .item
                |{{$t('gzzoc.age')}}: {{result.age}}

        .capture-dom(v-if="showCapture")
        .result-wrapper.thin-border-top
            .result-content(v-for='(item, index) in result.report')
                .result-img
                    img(:src="imgsrc(item.img)")
                    span.side {{item.side}}
                .result-item(v-if="item.diagnosis && item.diagnosis[0]")
                    .result-title {{item.diagnosis[0].title}}
                    .result-description.has-big-font
                        label {{item.diagnosis[0].explain}}
                .result-item.thin-border-top(v-if="item.assessment && item.assessment[0]")
                    .result-title {{item.assessment[0].title}}
                    .result-description.result-small-text
                        div(v-for='(info, j) in item.assessment') {{info.explain}}
                .result-item.thin-border-top(v-if="item.treatment && item.treatment[0]")
                    .result-title {{item.treatment[0].title}}
                    .result-description.has-big-font
                        label {{item.treatment[0].explain}}

        .result-sign(:class="langClass")
            .result-doctorSignature
                span.label {{$t('gzzoc.doctorSignature')}}:
                img(src="~public/images/gzzoc/CC-Cruiser.png")
            .result-data
                span.label {{$t('gzzoc.date')}}:
                span.value {{date}}


        .tips.thin-border-top
            .tip-title {{$t('ccIntroduction')}}：
            .tip-content(v-html='result.model_remark')
</template>

<script>
import _ from 'lodash';
import { languages, loadLanguageAsync } from "@/locale";

export default {
    data () {
        return {
            result: {
                report: []
            },
            showCapture: false
        };
    },
    computed: {
        id () {
            return this.$route.params.taskId;
        },
        date () {
            return this.$route.params.date;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        },
        langClass () {
            return {
                'en': this.lang.lang === 'en'
            };
        }
    },
    async mounted () {
        // webshot在截取页面时需要先将页面渲染出来，在后端渲染页面时会丢失用户在浏览器端设置的语言信息
        // 所以将语言信息放在路径中，渲染页面从路径中取出预测结果页要显示的语言，并进行设置
        // 这样就能正常使用 i18n 的功能了
        let lang = _.get(this.$route, 'params.lang');
        if (lang) {
            await loadLanguageAsync(lang);
        }
        this.getResult();
    },
    methods: {
        imgsrc (src) {
            return '/api/upl/s3/download/big/file?_id=' + src;
        },
        getResult () {
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: this.id,
                    lang: this.lang.lang
                }
            }).then(resp => {
                const status = _.get(resp, 'body.value.data.status');
                // 成功
                if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    this.result = result;
                    return;
                }
            }).finally(() => {
                this.$nextTick(() => {
                    setTimeout(() => { // 解决截图中存在loading状态的bug
                        this.showCapture = true;
                    }, 300);
                });
            });
        }
    }

};
</script>

<style lang="sass" scoped>
// gzzoc-pdf-wrapper 是为了防止 gzzoc-pdf 缩小后，露出带有图案的背景
.gzzoc-pdf-wrapper
    width: 100%
    height: 100%
    background-color: #FFF
    overflow-y: hidden
.gzzoc-pdf
    background-color: #FFF
    margin: 0 auto
    color: #000
    // 为了将预测结果在一页中打印出来，将页面以顶部中心为原点，缩小80%
    transform-origin: top center
    transform: scale(0.8, 0.8)
    .logo
        width: 196px
        height: 28px
    .title
        font-family: STSongti-SC-Black
        font-size: 24px
        line-height: 24px
        text-align: center
        margin-top: 21px
        white-space: pre-wrap
    .person
        font-family: STSongti-SC-Regular
        font-size: 12px
        color: #000000
        line-height: 12px
        padding-top: 20px
        padding-bottom: 15px
        display: flex
        justify-content: center
        .item
            display: inline-block
            margin: 0 30px
    .result-wrapper
        display: flex
        flex: 1 1
        justify-content: center
        padding-top: 20px
        .result-content
            &:not(:last-child)
                margin-right: 34px
        .result-img
            margin: 0 auto
            display: flex
            flex-direction: column
            align-items: center
            img
                width: 340px
                height: 340px
                background-color: #F9F9F9
                object-fit: cover
            .side
                font-family: STSongti-SC-Regular
                font-size: 12px
                color: #000000
                text-align: center
                margin-top: 10px
        .result-item
            padding-top: 10px
            padding-bottom: 10px
            &:first-child
                padding-top: 20px
            &:last-child
                padding-bottom: 0px
            .result-title
                font-family: STSongti-SC-Regular
                font-size: 12px
                line-height: 17px
                color: #000
            .result-description
                font-family: STSongti-SC-Regular
                font-size: 12px
                color: #000
                margin-top: 5px
                vertical-align: top
                &.has-big-font
                    label:first-child
                        font-size: 18px
                        line-height: 25px
                        display: block
                        width: 100%
            .result-small-text
                font-size: 12px
                line-height: 20px

    .result-sign
        float: right
        font-family: PingFangSC-Regular
        font-size: 12px
        color: #666
        line-height: 24px
        width: 210px
        margin-top: 20px
        margin-bottom: 10px
        &.en
            width: 200px
        .result-doctorSignature
            img
                width: 147px
                height: 24px
                transform: translateY(2px)
        .label
            margin-right: 5px
        .value
            color: #333
    .tips
        clear: both
        padding: 25px 0
        font-family: STSongti-SC-Regular
        font-size: 10px
        line-height: 14px
        color: #000
        .tip-content
            margin-top: 5px
        .tip-warm
            margin-top: 10px
</style>
